import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import type {AgentItemsState} from '../types';
import {agentItemsUpdated} from '../reducer';

export const useSetAgentItems = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (agentItems: AgentItemsState) => {
      dispatch(agentItemsUpdated(agentItems));
    },
    [dispatch],
  );
};
